import { render } from "./qualityInspection.vue?vue&type=template&id=1d4691ca&scoped=true"
import script from "./qualityInspection.vue?vue&type=script&lang=js"
export * from "./qualityInspection.vue?vue&type=script&lang=js"

import "./qualityInspection.vue?vue&type=style&index=0&id=1d4691ca&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d4691ca"]])

export default __exports__